<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Коллекции товаров
                                        </h3>
                                    </div>
                                    <div class="icons d-flex">
                                        <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('product-collection-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                        display_form = !display_form
                                                    ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div>
                                        <div class=" table-responsive" id="printableTable">

                                            <div id="productcollectionTable_wrapper" class="dataTables_wrapper no-footer">

                                                <div class="dataTables_length" id="productcollectionTable_length"><label>Показать
                                                        <select name="productcollectionTable_length"  class="" v-model="limit" v-on:change="fetchcollections()">
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                            <option value="500">500</option>
                                                            <option value="1000">1000</option>
                                                        </select> записей</label></div>

                                                <div id="productcollectionTable_filter" class="dataTables_filter">
                                                    <label>Поиск:<input type="text" class="" placeholder=""  v-model="searchParameter" @keyup="fetchcollections()"></label>
                                                    <button v-if="this.searchParameter != ''" @click="clearSearch">Очистить</button>
                                                </div>
                                                <table id="productcollectionTable" class="display dataTable no-footer" role="grid">
                                                    <thead class="text-body">
                                                        <tr role="row">
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 48.9797px;" @click="sorting('id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">
                                                                ID
                                                            </th>
                                                            <th class="sorting" tabindex="0"  rowspan="1" colspan="1" aria-label="collection: activate to sort column ascending" style="width: 113.2585px;" @click="sorting('name')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'name'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'name' ? 'sorting_desc' : 'sorting'">
                                                                Название
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 70.9188px;">
                                                                Состояние
                                                            </th>
                                                            <th v-if="$parent.permissions.includes('product-collection-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;">
                                                                Действие
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="kt-table-tbody text-dark">
                                                        <tr class="kt-table-row kt-table-row-level-0 odd" role="row" v-for="collection in collections" v-bind:key="collection.id">
                                                            <td class="sorting_1">
                                                                {{collection.id}}
                                                            </td>
                                                            <td>
                                                                {{ collection.name }}
                                                            </td>
                                                            <td>
                                                                {{ collection.status }}
                                                            </td>
                                                            <td v-if="$parent.permissions.includes('product-collection-manage')">
                                                                <a href="javascript:void(0)" class=" click-edit" id="click-edit1" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" @click="editcollection(collection)"><i class="fa fa-edit"></i></a>
                                                                <a class="" href="#" @click="deletecollection(collection.id)"><i class="fa fa-trash"></i></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination pagination-sm m-0 float-right">
                                                    <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><button class="page-link" href="#" @click="fetchcollections(pagination.prev_page_url)">Предыдущая</button></li>

                                                    <li class="disabled">
                                                        <span class="page-link text-dark text-center" href="#">Стр {{ pagination.current_page }} из {{ pagination.last_page }}</span>
                                                        <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="pagination.current_page" @keyup="changePage()" /></span>
                                                    </li>

                                                    <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item"><button class="page-link" href="#" @click="fetchcollections(pagination.next_page_url)">Следующая</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0" v-if="collection.id">Изменить коллекцию</h4>
            <h4 class="font-size-h4 font-weight-bold m-0" v-else>Добавить коллекцию</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="row">
                <div class="col-12">
                    <div class="form-group ">
                        <label class="text-dark">Название коллекции</label>
                        <input type="text"  v-model="collection.name" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('name')" v-text="errors.get('name')"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Изображения коллекции</label>
                        <small class="form-text text-muted">Загрузить изображения для коллекции.</small>
                        <small class="form-text text-danger" v-if="errors.has('media')" v-text="errors.get('media')"></small>

                        <!-- Main Image Display -->
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="col-12 slide-v" v-if="collection.images && collection.images.length > 0">
                                    <div class="slide">
                                        <input :id="`inputImage-main`" @change="(event) => {changeMainImage(event)}" type="file" name="file" accept="image/*">
                                        <label :for="`inputImage-main`">
                                            <img
                                                alt="Main collection image"
                                                :src="collection.images[currentSelectedImg] ? collection.images[currentSelectedImg].medium : ''"
                                                style="width: 100%; height: 200px; object-fit: cover; cursor: pointer;"
                                                class="border rounded"
                                            />
                                        </label>
                                    </div>
                                </div>

                                <!-- Placeholder when no images -->
                                <div class="col-12" v-else>
                                    <input id="inputImage-placeholder" @change="handleFileUpload" type="file" name="file" accept="image/*">
                                    <label for="inputImage-placeholder" class="btn btn-light border-dashed d-block text-center" style="height: 200px; line-height: 180px; cursor: pointer;">
                                        <i class="fas fa-plus"></i> Добавить изображение
                                    </label>
                                </div>

                                <!-- Thumbnail Images -->
                                <div class="col-12 d-flex justify-content-start flex-wrap mt-3" v-if="collection.images && collection.images.length > 0">
                                    <div v-for="(image, index) in collection.images" :key="image.id" class="col-2 mb-3 pl-1 pr-1">
                                        <input :id="`inputImages-${index}`" @change="(event) => {changeImage(event, index)}" type="file" name="file" accept="image/*">
                                        <label :for="`inputImages-${index}`">
                                            <img
                                                :src="image.thumbnail"
                                                alt="Collection thumbnail"
                                                class="img-thumbnail"
                                                style="cursor:pointer; width: 100%; height: 60px; object-fit: cover;"
                                                @click="currentSelectedImg = index"
                                            />
                                        </label>
                                        <button class="btn btn-block btn-danger btn-xs p-0 mt-1" @click="deleteImage(image.id, index)">×</button>
                                    </div>
                                </div>

                                <!-- Add More Images -->
                                <div class="col-12" v-if="collection.images && collection.images.length > 0">
                                    <hr>
                                    <input id="inputImages-multiple" @change="handleMultipleFileUpload" type="file" name="file" multiple accept="image/*">
                                    <label for="inputImages-multiple" class="btn btn-primary">
                                        <i class="fas fa-plus"></i> Добавить ещё изображения
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Состояние</label>
                        <fieldset class="form-group mb-3">
                            <select class="js-example-basic-single js-states form-control bg-transparent" v-model='collection.status' >
                                <option value="0">Выбрать состояние</option>
                                <option value="1">Активный</option>
                                <option value="0">Неактивный</option>
                            </select>
                            <small class="form-text text-danger" v-if="errors.has('status')" v-text="errors.get('status')"></small>
                        </fieldset>
                    </div>


                </div>
            </div>
            <button type="button" @click="addUpdatecollection()" class="btn btn-primary" style="position: absolute; right: 39px">Подтвердить</button>
        </form>
    </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";

export default {
    data() {
        return {
            display_form: 0,
            collection: {
                id: "",
                name: "",
                status: "",
                images: [],
                is_b2b: 0,
                b2b_price_factor: 0,
            },
            searchParameter: '',
            sortBy: 'id',
            sortType: 'ASC',
            limit: 10,
            error_message: '',
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            countrySelected: "",
            stateSelected: "",
            collections: [],
            languages: [],
            token: [],
            selectedLanguage: '',
            uploadingImage: false,
            currentSelectedImg: 0,
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        };
    },

    methods: {

        fetchcollections(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/collection";
            var arr = page_url.split('?');

            if (arr.length > 1) {
                page_url += '&limit=' + this.limit;
            } else {
                page_url += '?limit=' + this.limit;
            }
            if (this.searchParameter != null) {
                page_url += '&searchParameter=' + this.searchParameter;
            }
            page_url += '&sortBy=' + this.sortBy + '&sortType=' + this.sortType + '&getDetail=1';
            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.collections = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            }).finally(() => (this.$parent.loading = false));
        },

        changePage(){
          if(this.timer){
              clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
              if(this.pagination.current_page>this.pagination.last_page) {
                  this.pagination.current_page = this.pagination.last_page
              } else if(this.pagination.current_page<1 || isNaN(this.pagination.current_page)) {
                  this.pagination.current_page = 1
              }
              this.fetchcollections('/api/admin/collection?page='+this.pagination.current_page);
          }, 1000)
      },

        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        deletecollection(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/collection/${id}`, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success('Settings has been updated successfully')
                            this.fetchcollections();
                        }

                    })
                    .catch(error =>{
                        if (error.response.status == 422) {
                            if(error.response.data.status == 'Error'){
                                this.$toaster.error(error.response.data.message)
                            }
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addUpdatecollection() {
            this.$parent.loading = true;
            var url = '/api/admin/collection';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/collection/' + this.collection.id;
                this.request_method = 'put'
            }
            axios[this.request_method](url, {
                    name: this.collection.name,
                    status: this.collection.status,
                    is_b2b: this.collection.is_b2b,
                    b2b_price_factor: this.collection.b2b_price_factor,
                }, this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success('Settings has been updated successfully')
                        this.clearForm();
                        this.fetchcollections();
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == 'Error') {
                            this.error_message = error.response.data.message;
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                }).finally(() => (this.$parent.loading = false));

        },
        editcollection(collection) {
            this.edit = true;
            this.display_form = 1;
            this.errors = new ErrorHandling();
            this.collection.id = collection.id;
            this.collection.name = collection.name;
            this.collection.status = collection.status;
            this.collection.images = collection.images || [];
            this.collection.is_b2b = collection.is_b2b;
            this.collection.b2b_price_factor = collection.b2b_price_factor;
        },
        clearForm() {
            this.edit = false;
            this.collection.id = null;
            this.collection.name = '';
            this.collection.images = [];
            this.currentSelectedImg = 0;
            this.display_form = 0;
        },
        sorting(sortBy) {
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType = 'desc' : this.sortType = 'asc';
            this.fetchcollections();
        },
        setSelectedLanguage(selectedLanguage) {
            this.selectedLanguage = selectedLanguage;
            console.log("i am clicked", selectedLanguage)
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!this.collection.id) {
                this.$toaster.error('Please save the collection first before uploading images');
                return;
            }

            this.uploadingImage = true;
            const formData = new FormData();
            formData.append('media', file);

            axios.post(`/api/admin/collection/${this.collection.id}/upload-media`, formData, {
                headers: {
                    ...this.token.headers,
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                if (res.data.status == "Success") {
                    this.$toaster.success('Image uploaded successfully');
                    // Refresh collection data to get updated images
                    this.fetchUpdatedCollection();
                } else {
                    this.$toaster.error(res.data.message);
                }
            })
            .catch(error => {
                this.$toaster.error('Error uploading image');
                console.error('Upload error:', error);
            })
            .finally(() => {
                this.uploadingImage = false;
                // Reset file input
                event.target.value = '';
            });
        },

        deleteImage(mediaId, index) {
            if (!confirm('Are you sure you want to delete this image?')) return;

            axios({
                method: 'delete',
                url: `/api/admin/collection/${this.collection.id}/delete-media`,
                headers: this.token.headers,
                data: { media_id: mediaId }
            })
            .then(res => {
                if (res.data.status == "Success") {
                    this.$toaster.success('Image deleted successfully');
                    // Remove image from local data
                    this.collection.images = this.collection.images.filter(img => img.id !== mediaId);
                    // Adjust current selected image if necessary
                    if (this.currentSelectedImg >= this.collection.images.length) {
                        this.currentSelectedImg = Math.max(0, this.collection.images.length - 1);
                    }
                } else {
                    this.$toaster.error(res.data.message);
                }
            })
            .catch(error => {
                this.$toaster.error('Error deleting image');
                console.error('Delete error:', error);
            });
        },

        changeMainImage(event) {
            this.handleFileUpload(event);
        },

        changeImage(event, index) {
            this.handleFileUpload(event);
            this.currentSelectedImg = index;
        },

        handleMultipleFileUpload(event) {
            const files = Array.from(event.target.files);
            if (!files.length) return;

            if (!this.collection.id) {
                this.$toaster.error('Please save the collection first before uploading images');
                return;
            }

            this.uploadingImage = true;
            let uploadCount = 0;

            files.forEach(file => {
                const formData = new FormData();
                formData.append('media', file);

                axios.post(`/api/admin/collection/${this.collection.id}/upload-media`, formData, {
                    headers: {
                        ...this.token.headers,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    uploadCount++;
                    if (uploadCount === files.length) {
                        this.$toaster.success(`${files.length} images uploaded successfully`);
                        this.fetchUpdatedCollection();
                        this.uploadingImage = false;
                    }
                })
                .catch(error => {
                    this.$toaster.error(`Error uploading ${file.name}`);
                    console.error('Upload error:', error);
                    uploadCount++;
                    if (uploadCount === files.length) {
                        this.uploadingImage = false;
                    }
                });
            });

            // Reset file input
            event.target.value = '';
        },

        fetchUpdatedCollection() {
            if (!this.collection.id) return;

            axios.get(`/api/admin/collection/${this.collection.id}`, this.token)
            .then(res => {
                if (res.data.status == "Success" && res.data.data) {
                    this.collection.images = res.data.data.images || [];
                }
            })
            .catch(error => {
                console.error('Error fetching updated collection:', error);
            });
        },
        clearSearch(){
            this.searchParameter = "",
            this.fetchcollections();
        }
    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchcollections();
    }
};
</script>

<style scoped>
.border-dashed {
    border: 2px dashed #dee2e6 !important;
}
.border-dashed:hover {
    border-color: #007bff !important;
    background-color: #f8f9fa;
}
input[type="file"] {
    display: none;
}
.slide img:hover {
    opacity: 0.8;
}
.img-thumbnail:hover {
    opacity: 0.8;
}
</style>